import { ApexOptions } from "apexcharts";

const primary = "var(--theme-default)";
const secondary = "var(--theme-secondary)";

export const ExpensesChart: ApexOptions = {
  series: [
    {
      name: "Earning",
      data: [92, 64, 43, 80, 58, 92, 46, 76, 80, 30, 50],
    },
  ],
  chart: {
    type: "bar",
    offsetX: 15,
    toolbar: {
      show: false,
    },
    height: 170,
    stacked: true,
  },
  states: {
    hover: {
      filter: {
        type: "darken",
      },
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 3,
      columnWidth: "35%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  fill: {
    opacity: 1,
    colors: [secondary, "#F2F5FA"],
  },
  legend: {
    show: false,
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex }) {
      return `
      <div class="apex-tooltip p-2">
        <span>
          <span class="bg-primary"></span>
          Expenses
          <h3>$${series[seriesIndex][dataPointIndex]}</h3>
        </span>
      </div>
    `;
    },
  },
  responsive: [
    {
      breakpoint: 1200,
      options: {
        chart: {
          height: 210,
        },
      },
    },
  ],
};

export const EarningChart: ApexOptions = {
  series: [46],
  chart: {
    type: "radialBar",
    offsetY: -20,
    height: 200,
    sparkline: {
      enabled: true,
    },
  },
  plotOptions: {
    radialBar: {
      startAngle: -100,
      endAngle: 100,
      hollow: {
        size: "45%",
      },
      track: {
        background: "#e8eff2",
        strokeWidth: "90%",
        startAngle: -100,
        endAngle: 100,
      },
    },
  },
  grid: {
    padding: {
      top: -40,
      bottom: 0,
    },
  },
  stroke: {
    lineCap: "round",
  },
  colors: [primary],

  labels: ["Profile"],
  responsive: [
    {
      breakpoint: 1362,
      options: {
        chart: {
          height: 220,
        },
        grid: {
          padding: {
            top: -20,
          },
        },
      },
    },
  ],
};

export const SubscripationChart: ApexOptions = {
  series: [
    {
      name: "Desktops",
      data: [30, 50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
    },
  ],
  chart: {
    height: 135,
    type: "area",
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 0,
      left: 0,
      blur: 3,
      opacity: 0.2,
    },
  },
  colors: ["#dd7031"],
  fill: {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      opacityFrom: 0.4,
      opacityTo: 0.1,
      stops: [0, 100],
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "straight",
    width: 2,
  },
  tooltip: {
    enabled: false,
  },
  grid: {
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 1,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 6,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 9,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 12,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 13,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 16,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 19,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
    ],
  },
  responsive: [
    {
      breakpoint: 1362,
      options: {
        series: [
          {
            data: [30, 50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62],
          },
        ],
        chart: {
          height: 150,
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        series: [
          {
            data: [30, 50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
          },
        ],
        chart: {
          height: 150,
        },
      },
    },
  ],
};

export const GrowthChart: ApexOptions = {
  series: [
    {
      name: "Daily",
      type: "column",
      data: [0, 20, 8, 22, 8, 20, 8, 22, 8, 20, 8, 22],
    },
    {
      name: "Weekly",
      type: "area",
      data: [0, 12, 15, 25, 13, 24, 20, 26, 16, 22, 16, 0],
    },
    {
      name: "Monthly",
      type: "line",
      data: [0, 30, 25, 22, 35, 30, 40, 30, 39, 20, 34, 0],
    },
  ],
  chart: {
    height: 270,
    type: "line",
    stacked: false,
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 2,
      left: 0,
      blur: 4,
      color: "#000",
      opacity: 0.08,
    },
  },
  stroke: {
    width: [2, 2, 2],
    curve: "smooth",
    dashArray: [0, 0, 4],
  },
  grid: {
    show: true,
    borderColor: primary,
    strokeDashArray: 3,
    position: "back",
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
    padding: {
      top: -140,
      bottom: -13,
    },
  },
  plotOptions: {
    bar: {
      columnWidth: "1%",
    },
  },
  colors: [primary, "#dd7031", "#1a5f7f"],
  fill: {
    type: ["gradient", "gradient", "solid"],
    gradient: {
      shade: "light",
      type: "vertical",
      opacityFrom: 0.4,
      stops: [100, 100, 100],
    },
  },
  labels: ["Mon", " ", "Tue", " ", "Wed", " ", "Thu", " ", "Fri", " ", "Sat", "Sun"],
  markers: {
    size: [0, 4, 0],
  },
  xaxis: {
    type: "category",
    tickAmount: 4,
    tickPlacement: "between",
    tooltip: {
      enabled: false,
    },
    axisTicks: {
      show: false,
    },
  },
  legend: {
    show: false,
  },
  yaxis: {
    show: false,
    min: 0,
    tickAmount: 6,
  },
  tooltip: {
    shared: false,
    intersect: false,
  },
  responsive: [
    {
      breakpoint: 1300,
      options: {
        chart: {
          height: 280,
        },
      },
    },
    {
      breakpoint: 1362,
      options: {
        chart: {
          height: 280,
        },
        series: [
          {
            name: "Daily",
            type: "column",
            data: [],
          },
          {
            name: "Weekly",
            type: "area",
            data: [0, 12, 15, 25, 13, 24, 20, 26],
          },
          {
            name: "Monthly",
            type: "line",
            data: [0, 30, 25, 22, 35, 30, 40, 30],
          },
        ],
      },
    },
  ],
};

export const OrderOverView:ApexOptions = {
  series: [
    {
      name: "Earning",
      type: "area",
      data: [30, 100, 70, 120, 70, 95, 150],
    },
    {
      name: "Order", 
      type: "area", 
      data: [20, 50, 100, 90, 90, 50, 60],
    },
  ],
  chart: {
    height: 285,
    type: "line",
    stacked: false,
    toolbar: {
      show: false, 
    },
    dropShadow: {
      enabled: true,
      top: 2,
      left: 0,
      blur: 4,
      color: "#000",
      opacity: 0.08,
    },
  },
  stroke: {
    width: [2, 2, 2],
    curve: "straight",
  },
  grid: {
    show: true,
    borderColor: "var(--chart-border)", 
    strokeDashArray: 0,
    position: "back", 
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
    padding: {
      top: -230,
      right: 0,
      bottom: 0,
      left: 0
    }, 
  },
  plotOptions: {
    bar: {
      columnWidth: "50%",
    },
  },
  colors: ["#1a5f7f" ,"#dd7031"],
  fill: {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      opacityFrom: 0.4,
      opacityTo: 0,
      stops: [0, 100], 
    },
  }, 
  labels: [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun", 
  ],
  markers: {
    size: 5
  }, 
  xaxis: {
    type: "category",
    tickAmount: 4,
    tickPlacement: "between",
    tooltip: {
      enabled: false,
    },
    axisTicks: {
      show: false,
    },
  },
  legend: {
    show: false,
  },
  yaxis: {
    show: false,
    min: 0, 
    tickAmount: 6,
  },
  tooltip: {
    shared: false,
    intersect: false,
  },
  responsive: [
    {
      breakpoint: 1299,
      options: {
        chart: {
          height: 285,
        },
        series: [
          {
            name: "Earning", 
            type: "area",
            data: [0, 20, 70, 25, 100],
          },
          {
            name: "Order",
            type: "area",
            data: [0, 50, 40, 90, 60],
          },
        ],
      },
    },
  ],
};

export const ActivitiesData = [
  { image: "dashboard/activity/1.jpg", title: "Study application,Jim Smith", time: "jan 04 20 11:24 PM at Tame", date: "14m Ago" },
  { image: "dashboard/activity/2.jpg", title: "Fresh email was added", time: "jan 03 20 02:18 PM at Fresno", date: "22m Ago" },
  { image: "dashboard/activity/3.jpg", title: "Submit review (504)236-7302", time: "jan 04 20 08:40 PM at Iris", date: "30m Ago" },
];

export const TopUsersData = [
  { image: "dashboard/user/01.png", title: "Breno Ribeiro", price: "$240.00", button: "Completed", color: "success" },
  { image: "dashboard/user/02.png", title: "Vitor Souza", price: "$584.00", button: "Completed", color: "success" },
  { image: "dashboard/user/03.png", title: "Luiza Castro", price: "$986.00", button: "Pending", color: "warning" },
  { image: "dashboard/user/04.png", title: "Lara Araujo", price: "$456.00", button: "Canceled", color: "danger" },
  { image: "dashboard/user/05.png", title: "Vitor Alves", price: "$653.00", button: "Completed", color: "success" },
  { image: "dashboard/user/06.png", title: "Diego Lima", price: "$254.00", button: "Completed", color: "success" },
  { image: "dashboard/user/07.png", title: "Danilo Costa", price: "$351.00", button: "Canceled", color: "danger" },
];

export const TeamActivityData = [
  { image: "dashboard/user/8.png", title: "Alex Castro", time: "6 min ago", text: "Alex got into the warehouse." },
  { image: "dashboard/user/9.png", title: "Arthur Castro", time: "10 min ago", text: "Arthur has completed Mr. Williams' task." },
  { image: "dashboard/user/10.png", title: "Sofia Dias", time: "12 min ago", text: "Esther has changed his to active, now." },
  { image: "dashboard/user/11.png", title: "Luiz Lima", time: "16 min ago", text: "Luiz has updated his status to active currently." },
  { image: "dashboard/user/12.png", title: "Aline Souza", time: "18 min ago", text: "Aline has completed both old and new tasks." },
];

export const JobTodayHeaderData = [
  { color: "primary", svg: "job-bag", number: "40", title: "Total Jobs" },
  { color: "secondary", svg: "employees", number: "30", title: "Employees" },
  { color: "warning", svg: "hours-work", number: "40", title: "Hours of work" },
];
export const JobTodayTableData = [
  { time: "08:AM", job: "Upkeep", company: "Apple Inc.", name: "Isabelle Lima", image: "dashboard/user/1.png" },
  { time: "10:AM", job: "General", company: "Hewlett packard", name: "Lara Melo", image: "dashboard/user/2.png" },
  { time: "04:AM", job: "Cleaning", company: "Microsoft", name: "Martim Sous", image: "dashboard/user/3.png" },
];

export const TransactionData=[
  {image:"dashboard/product/4.png",title:"Ladies Bag",text:"₹44.55 delivery",date:"05 Mar 2025",time:"In 4 Days",income:"	-$40",color:"primary",status:"Credit Card"},
  {image:"dashboard/product/5.png",title:"Sunglasses",text:"Free delivery",date:"20 Jan 2025",time:"in 2 Months",income:"+$562",color:"secondary",status:"Paypal"},
  {image:"dashboard/product/3.png",title:"Nike Sports NK",text:"Free delivery",date:"22 Feb 2025",time:"In 2 Days",income:"+$546",color:"info",status:"Paypal"},
  {image:"dashboard/product/6.png",title:"Cotton T-shirt",text:"₹561.85 delivery",date:"25 Mar 2025",time:"In 3 Days",income:"-$685",color:"warning",status:"Credit Card"}
]
